import { useLegacyCurrentUser } from "./useCurrentUser"

const useIsAdmin = () => {
  const user = useLegacyCurrentUser({ suspense: false })
  return user?.role === "SUPERADMIN"
}

export default useIsAdmin
